<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chaptertitle3"><b>Acknowledgments</b></p>
<p class="body-text"><span class="small">MY DEBTS FOR THIS</span> volume are many. My gratitude goes to Patrick J. Deneen, series editor, for entrusting me in the first place with the joyous task of coordinating this volume and for extending that trust for as long as I needed. I owe Stephen M. Wrinn, the director of the University Press of Kentucky, my overflowing appreciation (and maybe an overflowing drink, too) for his wise counsel, unbounded patience, and unfailing good cheer at every step of the way toward producing this book. Thanks as well to Ila McEntire, Susan Murray, Candace Chaney, and all of their other supportive and talented colleagues at the University Press of Kentucky. Peter Kurtz and Emily Saliba served as my able assistants over separate summers, and I heartily thank them and the Pomona College SURP program for sponsoring such research. My appreciation extends to Princeton University's Center for Human Values for its generous support. I also want to acknowledge the tremendously helpful advice of several reviewers for this volume. Finally, I feel profoundly thankful for the efforts of the contributors to this volume: they are the worthy expositors of Whitman, and I have been wonderfully privileged to serve as their collaborator.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?5e82118e